/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns;

  ns = window.nspace("ccc.profileSelection");

  /**
   * Renders the display of the location type dropdowns and location buttons.
   */
  ns.IndicatorSelectionCreateProfileView = Backbone.View.extend({
    initialize: function(options) {
      _.bindAll(this);

      // Re-render on model changes
      this.model.on("change", this.render);
    },

    events: {
      click: "shouldPreventDefault"
    },

    shouldPreventDefault: function(e) {
      if (this.$(".disabled:first").length) {
        e.preventDefault();
        return;
      }

      // Let's ignore middle button clicks. This should open the link in a new tab
      // *without* closing the windowshade, which is probably the user's intention.
      if (e.which === 2) {
        return;
      }

      this.model.trigger("hrefChanged");
    },

    /**
     * A controlling method that renders everything relevant to this view's context.
     */
    render: function() {
      this.writeProfileUrl();
    },

    /**
     * Renders the customize profile anchor link according to the model state.
     */
    writeProfileUrl: function() {
      var location,
        locationType,
        locationTypeSlug,
        locationSlug,
        indicators,
        url;

      location = this.model.get("location");
      indicators = this.model.get("indicators");

      if (!location || !indicators || location === "n" || !indicators.length) {
        this.$("input").addClass("disabled");
        return;
      }

      locationType = this.model.get("locationType");
      locationTypeSlug = $(
        "a.location-type-link[data-loctype-id=" + locationType + "]:first"
      ).data("loctype-slug");

      locationSlug = this.model.get("locationSlug");
      if (!locationSlug) {
        this.model.set(
          "locationSlug",
          $(
            ".location-lists-container .subtopic-list button[data-loc-id=" +
              location +
              "]"
          ).data("loc-slug"),
          { silent: true }
        );
        locationSlug = this.model.get("locationSlug");
      }

      this.$("input").removeClass("disabled");

      url =
        "/profile/location/" +
        locationType +
        "/" +
        locationTypeSlug +
        "#" +
        location +
        "/" +
        locationSlug +
        "/" +
        locationType +
        "/" +
        indicators;
      this.$el.attr("href", url);
    }
  });
})(jQuery, _);
